export default "https://assets.egbcdn.net/assets/packs/_/images/chat/chat-trash-bin-0103c5fec40a8987fb067846971cfb6e.png";